import axios from 'axios';
const baseUrl = base.site_url;
const getPostsUrl = '/wp-json/wp/v2/community?_embed&per_page=100&categories';
const getCategoriesUrl = base.site_url + '/wp-json/wp/v2/community_category';
const getLocationCategories = base.site_url + '/wp-json/wp/v2/community_location';
const $api = axios.create({
  baseURL: baseUrl,
  method: ['get', 'post']
});
export const loadPosts = async () => {
  try {
    const response = await $api.get(getPostsUrl);
    return response.data;
  } catch (e) {
    console.log(e);
    return [];
  }
};
export const loadCategories = async () => {
  try {
    const response = await $api.get(getCategoriesUrl);
    return response.data;
  } catch (e) {
    console.log(e);
    return [];
  }
};
export const loadLocationCategories = async () => {
  try {
    const response = await $api.get(getLocationCategories);
    return response.data;
  } catch (e) {
    console.log(e);
    return [];
  }
};